/* tslint:disable */
/* eslint-disable */
/**
 * CrateHackers API
 * This is the thing that does data stuff.
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/**
 * Check if a given object implements the AnnouncementControllerUpload200Response interface.
 */
export function instanceOfAnnouncementControllerUpload200Response(value) {
    return true;
}
export function AnnouncementControllerUpload200ResponseFromJSON(json) {
    return AnnouncementControllerUpload200ResponseFromJSONTyped(json, false);
}
export function AnnouncementControllerUpload200ResponseFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'url': json['url'] == null ? undefined : json['url'],
    };
}
export function AnnouncementControllerUpload200ResponseToJSON(json) {
    return AnnouncementControllerUpload200ResponseToJSONTyped(json, false);
}
export function AnnouncementControllerUpload200ResponseToJSONTyped(value, ignoreDiscriminator = false) {
    if (value == null) {
        return value;
    }
    return {
        'url': value['url'],
    };
}
